import { render, staticRenderFns } from "./rune-recommendations.vue?vue&type=template&id=2833723a&scoped=true&"
import script from "./rune-recommendations.ts?vue&type=script&lang=ts&"
export * from "./rune-recommendations.ts?vue&type=script&lang=ts&"
import style0 from "./rune-recommendations.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./rune-recommendations.vue?vue&type=style&index=1&id=2833723a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2833723a",
  null
  
)

export default component.exports